<h1 mat-dialog-title>
  <ng-container i18n="General|Set password action label@@general-set-password-action-label">Set Password</ng-container>
</h1>
<div mat-dialog-content #dialogContent class="full-width dialog-content">
  <students-passwords [users]="users"
                      [changePassResults]="changePassResults"></students-passwords>
</div>
<div mat-dialog-actions>
  <app-button [disabled]="!users.length"
              icon="file_download"
              (clicked)="downloadFile(users)"
              matTooltip="Download"
              i18n-matTooltip="General|Download action label@@general-download-action-label"></app-button>
  <span class="fill-space"></span>
  <app-button [disabled]="inProgress"
              [secondary]="true"
              (clicked)="closeModal()"
              label="Close"
              i18n-label="General|Close action label@@general-close-action-label"></app-button>
</div>
